import { render } from "./StageView.vue?vue&type=template&id=28d1d5da"
import script from "./StageView.vue?vue&type=script&lang=js"
export * from "./StageView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programmazione\\Nodejs\\CallER\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__